import { Field } from "formik";
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { getList } from "../../libs/dbFunctions";

const FormikTypeAhead = ({
  dbType,
  company,
  placeholder,
  name,
  size,
  labelId = "id",
  labelKey = "name",
  className,
  label,
  onChange,
  constructLabel = null,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [searchResult, setSearchResult] = useState([]);

  const handleSearch = async (query) => {
    setIsLoading(true);
    try {
      let loadedRecords = await getList(dbType, company, {
        lastKey: null,
        searchStr: query || null,
        paginate: false,
      });
      setSearchResult(loadedRecords);
      if (loadedRecords && loadedRecords.length > 0) {
        let loadedOptions = loadedRecords.map((r) => {
          if (constructLabel) {
            return { id: r[labelId], [labelKey]: constructLabel(r) };
          } else {
            return { id: r[labelId], [labelKey]: r[labelKey] };
          }
        });

        setOptions(loadedOptions);
      } else {
        setOptions([]);
      }
    } catch (err) {
      return [];
    }

    setIsLoading(false);
  };

  // Bypass client-side filtering by returning `true`. Results are already
  // filtered by the search endpoint, so no need to do it again.
  const filterBy = () => true;

  return (
    <Field
      name={name}
      render={({ field, form }) => {
        const isValid = !form.errors[field.name];
        const isInvalid = form.touched[field.name] && !isValid;
        return (
          <Form.Group controlId={name} className={`form-group ${className}`}>
            <Form.Label>{label}</Form.Label>
            <AsyncTypeahead
              onBlur={() => form.setFieldTouched(field.name, true)}
              className={isInvalid ? "is-invalid" : ""}
              id={`id${name}`}
              size={size}
              filterBy={filterBy}
              isLoading={isLoading}
              labelKey={labelKey}
              minLength={3}
              isInvalid={isInvalid}
              onSearch={handleSearch}
              options={options}
              placeholder={placeholder}
              feedback={form.errors[field.name]}
              onChange={(str) => {
                let value = "";
                if (str && str.length > 0) {
                  value = str[0][labelId];
                }
                form.setFieldValue(name, value);
                if (onChange) {
                  onChange(value, searchResult);
                }
              }}
            />
            <Form.Control.Feedback type="invalid">
              {form.errors[field.name]}
            </Form.Control.Feedback>
          </Form.Group>
        );
      }}
    />
  );
};

export default FormikTypeAhead;
